import React from "react";
import { JOIN_LABEL, COVERAGE_CAPTION, COVERAGE_TYPE_LABEL, coverageText } from "./fusionApi";

// Exact on-screen wording (FUSION.md §7.2). Customer-facing: change only with the copy review.
const HEADING = "No connected chains yet";
const BODY = "A chain appears when findings from at least two modules are linked through the same identity, device, AI agent, control or vendor. Deal and business-unit membership are shown as context, not as links. Shared framework requirements do not form links.";
const VIEW_TEXT = "No chains match this view.";
const TABLE_CAPTION = "Links available in your data";

/**
 * Explains an empty Fusion instead of looking broken (FUSION.md §7.2).
 *  - variant "org": the organization has no chains; says what a chain needs and shows the entity-link
 *    counts of the caller's own graph (summary.entityLinks, one row per join type, zeros included).
 *    When summary.coverage is a non-empty array (store mode) a "Where links come from" table replaces the counts.
 *  - variant "view": the organization has chains but this scope or filter has none; no table.
 * The Partial view banner is the panel's, not this component's.
 */
const FusionEmptyState = ({ variant = "org", entityLinks, coverage }) => {
  if (variant === "view") {
    return (
      <div className="rounded-lg border border-dashed border-border px-4 py-6 text-center text-sm text-content-secondary">
        {VIEW_TEXT}
      </div>
    );
  }
  const rows = entityLinks || [];
  const coverageRows = Array.isArray(coverage) ? coverage : [];
  return (
    <div className="rounded-lg border border-dashed border-border px-4 py-5 text-sm text-content-secondary">
      <div className="font-semibold text-content-primary mb-1">{HEADING}</div>
      <p className="mb-3">{BODY}</p>
      {coverageRows.length > 0 ? (
        <table className="text-xs">
          <caption className="text-left font-medium text-content-primary mb-1">{COVERAGE_CAPTION}</caption>
          <tbody>
            {coverageRows.map((r) => (
              <tr key={r.relationshipType}>
                <td className="pr-4 py-0.5">{COVERAGE_TYPE_LABEL[r.relationshipType] || r.relationshipType}</td>
                <td className="py-0.5 text-right text-content-primary">{coverageText(r)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : rows.length > 0 && (
        <table className="text-xs">
          <caption className="text-left font-medium text-content-primary mb-1">{TABLE_CAPTION}</caption>
          <tbody>
            {rows.map((r) => (
              <tr key={r.joinType}>
                <td className="pr-4 py-0.5">{JOIN_LABEL[r.joinType] || r.joinType}</td>
                <td className="py-0.5 text-right tabular-nums text-content-primary">{Number(r.count || 0).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default FusionEmptyState;
